module.exports = __webpack_public_path__ + "static/img/SIENNA_PAINT.55e2cc5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/SIENNA_PAINT.jpg
// module id = TImM
// module chunks = 0